export default function NotificationBell() {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.000244141" width="44" height="44" rx="22" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23 13.0002C23 12.448 22.5523 12.0002 22 12.0002C21.4477 12.0002 21 12.448 21 13.0002V14.0711C17.6077 14.5564 15 17.4738 15 21.0002V28.0002H14C13.4477 28.0002 13 28.448 13 29.0002C13 29.5525 13.4477 30.0002 14 30.0002H15H16H28H29H30C30.5523 30.0002 31 29.5525 31 29.0002C31 28.448 30.5523 28.0002 30 28.0002H29V21.0002C29 17.4738 26.3923 14.5564 23 14.0711V13.0002ZM27 28.0002V21.0002C27 18.2388 24.7614 16.0002 22 16.0002C19.2386 16.0002 17 18.2388 17 21.0002V28.0002H27ZM22 33.0002C20.8954 33.0002 20 32.1048 20 31.0002H22H24C24 32.1048 23.1046 33.0002 22 33.0002Z"
        fill="#EB9F23"
      />
    </svg>
  );
}
